module.exports = __webpack_public_path__ + "static/media/door.468fac87.png";